import navbar from "./json/navbar.json"
import solution from "./json/solution.json"
import service from "./json/service.json"
import company from "./json/company.json"
import footer from "./json/footer.json"
import home from "./json/home.json"
import product from './json/product.json'

export default {
    navbar,
    solution,
    service,
    company,
    footer,
    home,
    product
}